const UserLogLevel = Object.freeze({
  CUSTOMER: 'CUSTOMER',
  NETBASE: 'NETBASE',
  NETBASE_DEMO: 'NETBASE_DEMO',
  NETBASE_FAE: 'NETBASE_FAE',
  TESTING_BOT: 'TESTING_BOT'
})
export default UserLogLevel
// RESERVE BELOW
